import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useSelector, useDispatch } from 'react-redux';
import { selectHostStatus, HOST_STATUS, pauseNarration, resumeNarration } from '../hostStateSlice';
import { selectGameId } from 'features/gamestate/gameStateSlice';
import logging from 'utils/logging';

const log = logging.getLogger('PauseButton');

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  color: '#222',
  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
  zIndex: 1000,
  width: '56px',
  height: '56px',
  '& .MuiSvgIcon-root': {
    fontSize: '2rem',
  },
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxShadow: '0 6px 25px rgba(0,0,0,0.2)',
  },
}));

const PauseButton = () => {
  const dispatch = useDispatch();
  const hostStatus = useSelector(selectHostStatus);
  const gameId = useSelector(selectGameId);
  
  // Only show button when speaking or paused
  const shouldShow = hostStatus === HOST_STATUS.SPEAKING || hostStatus === HOST_STATUS.PAUSED;
  const isPaused = hostStatus === HOST_STATUS.PAUSED;
  
  const handleClick = () => {
    if (!gameId) {
      log.warn('No game ID available for pause/resume');
      return;
    }
    
    if (isPaused) {
      log.info('Resume button clicked');
      dispatch(resumeNarration({ gameId }));
    } else {
      log.info('Pause button clicked');
      dispatch(pauseNarration({ gameId }));
    }
  };
  
  if (!shouldShow) {
    return null;
  }
  
  return (
    <Tooltip title={isPaused ? "Resume Audio" : "Pause Audio"}>
      <StyledIconButton onClick={handleClick} size="large">
        {isPaused ? <PlayArrowIcon /> : <PauseIcon />}
      </StyledIconButton>
    </Tooltip>
  );
};

export default PauseButton; 